import { FOR_YOU } from '@/constants/tabConfig';
import { EmptyState } from '../EmptyState';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
    makeItPersonal: {
        id: "Let's make it personal",
        defaultMessage: "Let's make it personal",
    },
    loginDescription: {
        id: 'Log in and tell us what you love to get event picks based on your interests',
        defaultMessage:
            'Log in and tell us what you love to get event picks based on your interests',
    },
    getStarted: {
        id: 'Get started',
        defaultMessage: 'Get started',
    },
});

export const DoLoginEmptyState = () => {
    return (
        <EmptyState
            bucketKey={FOR_YOU}
            emptyState={[
                {
                    validation: { shouldShowEmptyState: true },
                    config: {
                        title: messages.makeItPersonal,
                        iconType: 'EmptyState',
                        iconSize: 'xlarge',
                        description: messages.loginDescription,
                        primaryText: messages.getStarted,
                        primaryLink: '/login/?referrer=%2F',
                        buttonStyle: 'fill',
                    },
                },
            ]}
        />
    );
};
